import { api, ENDPOINTS } from '../config';
import type { SitesResponseData, SiteWithEUI } from './types';

/**
 * Fetch all sites
 */
export async function getSites(): Promise<SitesResponseData> {
  const response = await api.get(ENDPOINTS.SITES);
  
  return response;
}

/**
 * Fetch sites with calculated EUI (Energy Use Intensity)
 * EUI = yearly_energy_interpolated / area
 */
export async function getSitesWithEUI(): Promise<SiteWithEUI[]> {
  const response = await getSites();
  
  return response.data.map(site => ({
    ...site,
    eui: site.metadata.yearly_energy_interpolated / site.metadata.area
  }));
}

/**
 * Fetch sites with latest_data expanded
 */
export async function getSitesWithLatestData(): Promise<SitesResponseData> {
  const response = await api.get(`${ENDPOINTS.SITES}?expand=latest_data`);
  
  return response;
}